// extracted by mini-css-extract-plugin
export default {"review":"Reviews_review__DUmcy","reviewBrief":"Reviews_reviewBrief__tDyoc","reviewItems":"Reviews_reviewItems__3ltHg"};